import { useEffect } from 'react';

interface ImageLightboxProps {
  imageUrl: string;
  title: string;
  onClose: () => void;
}

export function ImageLightbox({ imageUrl, title, onClose }: ImageLightboxProps) {
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="image-lightbox" role="presentation" onMouseDown={onClose}>
      <div className="image-lightbox-panel" role="dialog" aria-modal="true" aria-label={`Imagen ampliada de ${title}`} onMouseDown={(event) => event.stopPropagation()}>
        <div className="image-lightbox-header">
          <h2>{title}</h2>
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose} aria-label="Cerrar imagen ampliada">
            Cerrar
          </button>
        </div>
        <img src={imageUrl} alt={`Imagen ampliada de ${title}`} />
      </div>
    </div>
  );
}
